<template>
  <div id="home">
    <LoginHomeComponent />
  </div>
</template>

<script>

import LoginHomeComponent from '../components/login/LoginHomeComponent.vue'

export default {
	components: {
  	LoginHomeComponent
	}
}
</script>

<style lang="stylus" scoped>
h1
  color: green

#home
  background:url('../assets/img/background.png');
  background-size: cover;
  height: 100%;
  text-align: center;
</style>
